import * as React from 'react';

import { Button, FormControl } from '@material-ui/core';
import { action, observable } from 'mobx';
import { Provider, inject, observer } from 'mobx-react';

import { withStyles } from '@material-ui/core';
import type HistoryStore from 'connect/web/src/stores/history-store';
import type SearchStore from 'connect/web/src/stores/search-store';
import { SearchType } from 'connect/web/src/stores/search-store';
import EConnectSearchFilterMode from './EConnectSearchFilterMode';
import Location from './controls/locations';
import SearchTypeControl from './controls/search-type';
import Services from './controls/services';
import SearchBarStore from './stores/search-bar-store';
import styles from './styles';

interface IProps {
  classes: {
    searchField: string;
    searchFields: string;
    searchFieldsNoFilter: string;
    button: string;
  };
  historyStore?: HistoryStore;
  searchStore?: SearchStore;
  subtitle: string;
  searchFilterMode?: EConnectSearchFilterMode;
}

@inject('historyStore', 'searchStore')
@observer
class Search extends React.Component<IProps> {
  searchBarStore: SearchBarStore;

  constructor(props: IProps) {
    super(props);
    const { searchStore, searchFilterMode } = props;
    const { locationId } = searchStore!;

    let services;
    if (searchFilterMode == EConnectSearchFilterMode.ClassesOnly) {
      services = searchStore!.services.filter((x) => x.isClassService);
    } else if (searchFilterMode == EConnectSearchFilterMode.AppointmentsOnly) {
      services = searchStore!.services.filter((x) => !x.isClassService);
    } else {
      services = searchStore!.services;
    }

    this.searchBarStore = new SearchBarStore(
      searchStore!.locations,
      services,
      searchStore!.categories
    );
    if (locationId) {
      this.searchBarStore.locationId = locationId;
    }
  }

  render() {
    const {
      classes: { searchFields, searchFieldsNoFilter, searchField, button },
      subtitle,
      searchStore,
      searchFilterMode
    } = this.props;

    let searchFilter = searchStore?.hasAppointments && searchStore?.hasClasses;
    if (!!searchFilterMode) {
      searchFilter = false;
    }

    let searchFilterClass = searchFields;
    if (!searchFilter) {
      searchFilterClass = searchFieldsNoFilter;
    }
    let subtitleText = null;
    if (!!subtitle) {
      subtitleText = <p>{subtitle}</p>;
    }
    return (
      <div className="container">
        {subtitleText}
        <div className={searchFilterClass}>
          <Provider searchBarStore={this.searchBarStore}>
            <React.Fragment>
              <Location className={searchField} />
              {searchFilter ? <SearchTypeControl className={searchField} /> : null}
              <Services className={searchField} />
              <FormControl variant="outlined" className={button}>
                <Button variant="contained" color="primary" onClick={this.onClick}>
                  Search
                </Button>
              </FormControl>
            </React.Fragment>
          </Provider>
        </div>
      </div>
    );
  }

  @action.bound
  private onClick(): void {
    const { historyStore, searchStore, searchFilterMode } = this.props;
    const { searchBarStore } = this;
    const { searchMode, locationId, route } = searchBarStore;

    let searchType = searchMode;
    if (!!searchFilterMode) {
      searchType =
        searchFilterMode == EConnectSearchFilterMode.AppointmentsOnly
          ? SearchType.Appointment
          : SearchType.Class;
    }

    searchStore!.mode = searchType;
    searchStore!.locationId = locationId;

    historyStore!.push('/book' + route);
  }
}

export default withStyles(styles)(Search);
